module.exports = __webpack_public_path__ + "static/media/omnilert_logo_flat_dark.677c9051.png";